import * as React from "react";
import { useState } from "react";

export function Contact() {
  const [form, setValues] = useState({
    senderFirstname: "",
    senderName: "",
    senderEmail: "",
    subject: "",
    message: "",
    phone: "",
    people: "",
    budget: "",
    date: "",
    place: "",
  });

  const [formStatus, setFormStatus] = useState({
    valid: true,
    message: "",
    isButtonDisabled: false
  });

  const updateField = (e) => {
    setValues({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  function isEmpty(str) {
    return !str || 0 === str.length;
  }

  function isValideEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function updateCRM(data) {
    const currentDate = new Date();
    const timestamp = currentDate.getTime();

    data = {
      submittedAt: timestamp,
      fields: [
        {
          name: "email",
          value: isValideEmail(form.senderEmail)
            ? form.senderEmail
            : "info@pitsbbq.fr",
        },
        {
          name: "lastname",
          value: form.senderName,
        },
        {
          name: "firstname",
          value: form.senderFirstname,
        },
        {
          name: "phone",
          value: form.phone
            .replace(".", "")
            .replace(/ /g, "")
            .replace(/\D/g, ""),
        },
        {
          name: "nombre_de_personnes",
          value: form.people,
        },
        {
          name: "budget",
          value: form.budget,
        },
        {
          name: "date",
          value: form.date,
        },
        {
          name: "lieu",
          value: form.place,
        },
        {
          name: "message",
          value: form.message,
        },
      ],
    };

    var xhr = new XMLHttpRequest();
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/7176912/9a4ba28c-daeb-4920-b635-492afc609f3f";

    var final_data = JSON.stringify(data);
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(final_data);
  }

 function sendEmail() {
    setFormStatus({
      isButtonDisabled: true,
      valid: true,
      message: "",
    });

    if (
      !isEmpty(form.senderFirstname) &&
      !isEmpty(form.senderName) &&
      !isEmpty(form.senderEmail) &&
      !isEmpty(form.phone) &&
      !isEmpty(form.people) &&
      !isEmpty(form.budget) &&
      !isEmpty(form.date) &&
      !isEmpty(form.place)
    ) {
      const currentPath = window.location.href;
      var data = {
        senderName: form.senderFirstname + " " + form.senderName,
        senderEmail: 'info@pitsbbq.fr',
        subject: "Pit's BBQ Contact",
        message: `
        Message: ${form.message}
        Numéro de téléphone: ${form.phone}
        Nombre de personnes: ${form.people}
        Budget: ${form.budget}
        Date: ${form.date}
        Adresse email du prospect: ${form.senderEmail},
        Lieu: ${form.place},
        `,
      };

      // fetch("https://sendgrid-pits-email.azurewebsites.net/api/SendEmail", {
      fetch("https://graindecelprospectdb.azurewebsites.net/api/CreateProspect", {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      })
        .then((response) => {
          if (response.ok === false) {
            setFormStatus({
              isButtonDisabled: false,
              valid: false,
              message:
                "Notre service de contact est non fonctionnel, veuillez nous contacter au 07.85.84.29.25",
            });
          }
        })
        .then((_) => {
          setFormStatus({
            isButtonDisabled: false,
            valid: true,
            message: "Votre message a été envoyé. Votre devis vous sera adressé sous 48 à 72h ouvrés, pensez à vérifier dans vos spams.",
          });
        })
        .catch((error) => {
          setFormStatus({
            isButtonDisabled: false,
            valid: false,
            message:
              "Notre service de contact est non fonctionnel, veuillez nous contacter au 07.85.84.29.25",
          });
        });
      updateCRM(data);  
    } else {
      if (isEmpty(form.senderName)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ votre Nom",
        });
      }
      if (isEmpty(form.senderFirstname)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ votre Prénom",
        });
      }
      if (isEmpty(form.senderEmail)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ votre Email",
        });
      }
      if (isEmpty(form.phone)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ votre numéro de téléphone",
        });
      }
      if (isEmpty(form.people)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ le nombre de personnes",
        });
      }
      if (isEmpty(form.budget)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ le budget",
        });
      }
      if (isEmpty(form.date)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ la date",
        });
      }
      if (isEmpty(form.place)) {
        setFormStatus({
          isButtonDisabled: false,
          valid: false,
          message: "Veuillez compléter le champ le lieu",
        });
      }
    }
  }
  return (
    <div className="contact-form">
      {formStatus.valid === false && (
        <div className="errors">{formStatus.message}</div>
      )}
      {formStatus.valid === true && formStatus.message !== "" && (
        <div className="success">{formStatus.message}</div>
      )}
      <p>
        <label htmlFor="senderName">VOTRE NOM</label>
        <br />
        <input
          id="senderName"
          name="senderName"
          type="text"
          onChange={updateField}
          value={form.senderName}
        />
      </p>
      <p>
        <label htmlFor="senderFirstname">VOTRE PRENOM</label>
        <br />
        <input
          id="senderFirstname"
          name="senderFirstname"
          type="text"
          onChange={updateField}
          value={form.senderFirstname}
        />
      </p>      
      <p>
        <label htmlFor="senderEmail">VOTRE EMAIL</label>
        <br />
        <input
          id="senderEmail"
          type="email"
          name="senderEmail"
          onChange={updateField}
          value={form.senderEmail}
        />
      </p>
      <p>
        <label htmlFor="phone">TÉLÉPHONE</label>
        <br />
        <span className="phone">
          <input
            id="phone"
            type="text"
            name="phone"
            onChange={updateField}
            value={form.phone}
          />
        </span>
      </p>
      <p>
        <label htmlFor="people">NOMBRE DE PERSONNES</label>
        <br />
        <span className="nbre-personnes">
          <input
            id="people"
            type="text"
            name="people"
            onChange={updateField}
            value={form.people}
          />
        </span>
      </p>
      <p>
        <label htmlFor="budget">BUDGET</label>
        <br />
        <span className="budget">
          <input
            id="budget"
            type="text"
            name="budget"
            onChange={updateField}
            value={form.budget}
          />
        </span>
      </p>
      <p>
        <label htmlFor="date">DATE</label>
        <br />
        <span className="date">
          <input
            id="date"
            type="date"
            name="date"
            onChange={updateField}
            value={form.date}
          />
        </span>
      </p>
      <p>
        <label htmlFor="place">LIEU</label>
        <br />
        <span className="lieu">
          <input
            id="place"
            type="text"
            name="place"
            onChange={updateField}
            value={form.place}
          />
        </span>
      </p>
      <p>
        <label htmlFor="message">VOTRE MESSAGE</label>
        <br />
        <span className="message">
          <textarea
            id="message"
            name="message"
            onChange={updateField}
            value={form.message}
          ></textarea>
        </span>
      </p>
      <div>
        {formStatus.valid === false && (
          <div className="errors">{formStatus.message}</div>
        )}
        {formStatus.valid === true && formStatus.message !== "" && (
          <div className="success">{formStatus.message}</div>
        )}
      </div>
      <p className="submit">
        <button onClick={sendEmail} disabled={formStatus.isButtonDisabled}>Envoyer</button>
      </p>
    </div>
  );
}
